import { TFunction } from 'i18next';

/**
 * Translates backend error messages to localized strings
 */
export function translateError(error: string, t: TFunction): string {
  if (!error) return '';

  // Map of backend error messages to translation keys
  const errorMap: Record<string, string> = {
    'path is blocked - cannot jump over pieces': 'errors.pathBlocked',
    'cannot land on your own piece': 'errors.cannotLandOnOwnPiece',
    'piece is in corner, must roll 6 to place it': 'errors.pieceInCorner',
    'piece is already in center': 'errors.pieceAlreadyInCenter',
    'need to roll a 6 to place piece': 'errors.needToRoll6',
    'piece is not in corner': 'errors.pieceNotInCorner',
    'piece not found or not owned by current player': 'errors.pieceNotFound',
    'not your turn': 'errors.notYourTurn',
    'game not in progress': 'errors.gameNotInProgress',
    'steps must match dice roll': 'errors.stepsMustMatchDice',
    'need exact roll to reach center - cannot overshoot': 'errors.needExactRollForCenter',
    'only the game creator can start the game': 'errors.onlyCreatorCanStart',
    'player name is already taken': 'errors.playerNameTaken',
  };

  // Try to find exact match (case-insensitive)
  const lowerError = error.toLowerCase();
  for (const [backendMsg, translationKey] of Object.entries(errorMap)) {
    if (lowerError === backendMsg.toLowerCase()) {
      return t(translationKey);
    }
  }

  // Try to find partial match
  for (const [backendMsg, translationKey] of Object.entries(errorMap)) {
    if (lowerError.includes(backendMsg.toLowerCase())) {
      return t(translationKey);
    }
  }

  // If no match found, return original error
  return error;
}
